const mediaItems = [
  {
    title: '《风暴追击》官方预告片',
    desc: '年度最受期待的动作巨制，震撼视听效果抢先看',
    duration: '2:35',
    views: '12.8万',
    img: 'https://readdy.ai/api/search-image?query=Action%20movie%20trailer%20thumbnail%20with%20dramatic%20cinematic%20composition%2C%20intense%20warm%20golden%20lighting%2C%20dark%20atmospheric%20background%2C%20professional%20film%20promotional%20image%20with%20epic%20scale%2C%20movie%20poster%20aesthetic&width=800&height=500&seq=media-01&orientation=landscape',
    alt: '风暴追击官方预告片',
  },
  {
    title: '喜剧之王：幕后花絮特辑',
    desc: '那些经典笑场瞬间和未公开的片场趣事',
    duration: '4:18',
    views: '8.5万',
    img: 'https://readdy.ai/api/search-image?query=Comedy%20film%20behind%20the%20scenes%20thumbnail%20with%20bright%20cheerful%20atmosphere%2C%20warm%20vibrant%20colors%2C%20playful%20cinematic%20composition%2C%20professional%20film%20set%20photography%20with%20crew%20and%20equipment&width=800&height=500&seq=media-02&orientation=landscape',
    alt: '喜剧之王幕后花絮特辑',
  },
  {
    title: '科幻电影特效进化史',
    desc: '从模型实拍到数字CG，见证电影工业的技术革命',
    duration: '6:42',
    views: '15.3万',
    img: 'https://readdy.ai/api/search-image?query=Science%20fiction%20film%20visual%20effects%20comparison%20thumbnail%2C%20futuristic%20cinematic%20aesthetic%20with%20deep%20space%20and%20digital%20elements%2C%20professional%20VFX%20showcase%20style%2C%20dark%20moody%20background%20with%20glowing%20accents&width=800&height=500&seq=media-03&orientation=landscape',
    alt: '科幻电影特效进化史',
  },
  {
    title: '全球影迷票选TOP10经典台词',
    desc: '那些被反复引用、刻进DNA里的电影经典瞬间',
    duration: '3:55',
    views: '9.7万',
    img: 'https://readdy.ai/api/search-image?query=Classic%20film%20iconic%20moments%20collage%20thumbnail%2C%20nostalgic%20warm%20golden%20cinematic%20aesthetic%2C%20professional%20film%20history%20montage%20style%2C%20elegant%20vintage%20movie%20theater%20atmosphere%2C%20rich%20textured%20background&width=800&height=500&seq=media-04&orientation=landscape',
    alt: '全球影迷票选TOP10经典台词',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-16 md:py-24 bg-background-50">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 text-xs font-medium text-accent-300 bg-accent-500/10 rounded-full mb-4">
            精彩预告
          </span>
          <h2 className="text-2xl md:text-4xl font-bold font-heading text-foreground-50 mb-3">
            精彩预告与花絮
          </h2>
          <p className="text-sm md:text-base text-foreground-400 max-w-[560px] mx-auto">
            预告片、幕后花絮、深度解析，提前感受电影的无穷魅力
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {mediaItems.map((item, idx) => (
            <div
              key={idx}
              className="group rounded-xl overflow-hidden bg-background-200 border border-background-300/40 cursor-pointer transition-all duration-300 hover:border-accent-500/25"
            >
              <div className="relative aspect-video overflow-hidden bg-background-300">
                <img
                  src={item.img}
                  alt={item.alt}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  onError={(e) => { (e.target as HTMLElement).parentElement!.style.display = 'none'; }}
                />
                <div className="absolute inset-0 bg-background-950/30 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-accent-500/90">
                    <i className="ri-play-fill text-background-50 text-xl md:text-2xl ml-0.5"></i>
                  </div>
                </div>
                <div className="absolute bottom-2 right-2 px-2 py-0.5 rounded bg-background-950/70 text-xs text-foreground-300">
                  {item.duration}
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm md:text-base font-semibold text-foreground-200 mb-1 line-clamp-1">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2 mb-2">
                  {item.desc}
                </p>
                <span className="text-xs text-foreground-600">
                  <i className="ri-eye-line mr-1"></i>{item.views} 次播放
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}